import { Button, Grid, Paper, styled } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { setStateVariable, updateStateVariables } from "../../AppAction";
import "./Gallery.css";
import { DOCUMENT_SETSTATE } from "./GalleryActionType";
import { openPopup } from "../CommonPopup/PopupReducer";

const apiConfig = window as any;

const GridEditTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#82b6e5',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[2],
        fontSize: 11,
    },
}));



class GalleryPage extends React.Component<Props> {



    async componentDidMount() {
        const { setStateVariable, updateStateVariables } = this.props;
        // setStateVariable(APP_SETSTATE, "isShowBackdrop", true);

        //Find Images that starts with CROP
        // var data = require("../../Images/Img.json");
        // const loadData = () => JSON.parse(JSON.stringify(img));
        // const loadData = () => fetch('./GalleryImages/Img.json')
        //     .then((res) => res.json())
        //     .then((data) => {
        //         console.log('data:', data);
        //     });
        // console.log(loadData);
        // setStateVariable(APP_SETSTATE, "isShowBackdrop", true);
    }


    shouldComponentUpdate() {
        return true;
    }

    handleDrawerToggle = () => {
        console.log("Test");
    }

    showMoreIceCarvingImage = () => {
        const { setStateVariable, updateStateVariables } = this.props;
        const { galReducer } = this.props;
        if (parseInt(galReducer.intIceImage) < apiConfig.GALLARY_ICE_IMAGE_STOP_COUNTER)
            setStateVariable(DOCUMENT_SETSTATE, "intIceImage", parseInt(galReducer.intIceImage) + 10);
    }


    showMoreVegCarvingImage = () => {
        const { setStateVariable, updateStateVariables } = this.props;
        const { galReducer } = this.props;
        if (parseInt(galReducer.intVegImage) < apiConfig.GALLARY_VEG_IMAGE_STOP_COUNTER)
            setStateVariable(DOCUMENT_SETSTATE, "intVegImage", parseInt(galReducer.intVegImage) + 10);
    }

    galleryPage = () => {
        const { galReducer, openPopup } = this.props;

        console.log(" galReducer.intIceImage" + galReducer.intIceImage);

        const iceCarvlistOfImg = [];
        for (let index = 1; index < galReducer.intIceImage; index++) {

            const gallObj = {
                "name": "IC_" + index + ".jpg"
            }
            iceCarvlistOfImg.push(gallObj);
        }

        const counterVeg = galReducer.intVegImage;
        const vegCarvlistOfImg = [];
        // for (let index = 1; index < carving.galleryItemsCounter; index++) {
        for (let index = 1; index < counterVeg; index++) {

            const gallObj = {
                // "name": "/Images/" + "Crop" + index + ".jpg"
                "name": "VC_" + index + ".jpg"
            }
            vegCarvlistOfImg.push(gallObj);
        }
        // const container = window !== undefined ? () => document.body : undefined;
        return (
            <div >

                <fieldset>
                    <legend className="legendClass"> Ice Carvings</legend>
                    <Grid container spacing={2} className="carvingGridContainerClass">
                        {
                            iceCarvlistOfImg.map((abc: any, k: any) => {
                                return (
                                    <Grid key={k} xs={12} sm={3} item>
                                        <Paper key={k} className="imgPaperClass">
                                            {/* <img src={abc.name} className='carouselImg'></img> */}

                                            <img src={process.env.PUBLIC_URL +
                                                "/CarvingImages/IceCarving/" + abc.name} className='galleryImgClass' style={{ cursor: "pointer" }}
                                                onClick={() => openPopup(process.env.PUBLIC_URL + "/CarvingImages/IceCarving/" + abc.name)}
                                            />
                                        </Paper>
                                    </Grid>)
                            })}
                    </Grid>
                    <br />
                    <Button size="medium" className="cardButton" onClick={this.showMoreIceCarvingImage}> Show More</Button>
                </fieldset>



                <fieldset>
                    <legend className="legendClass"> Veg Carvings</legend>
                    <Grid container spacing={2} className="carvingGridContainerClass">
                        {
                            vegCarvlistOfImg.map((abc: any, k: any) => {
                                return (
                                    <Grid key={k} xs={12} sm={3} item>
                                        <Paper key={k} className="imgPaperClass">
                                            <img src={process.env.PUBLIC_URL +
                                                "/CarvingImages/VegCarvings/" + abc.name} className='galleryImgClass' style={{ cursor: "pointer" }}
                                                onClick={() => openPopup(process.env.PUBLIC_URL + "/CarvingImages/VegCarvings/" + abc.name)}></img>
                                        </Paper>
                                    </Grid>)
                            })}
                    </Grid>
                    <br />
                    <Button size="medium" className="cardButton" onClick={this.showMoreVegCarvingImage}> Show More</Button>
                </fieldset>



            </div>
        );
    }


    render() {
        return (
            <div className="fullWidth">
                <Grid container>
                    <Grid item xs={12} className="galleryHeader" >
                        Gallery
                    </Grid>
                </Grid>
                <div>
                    <this.galleryPage />
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    const app = state.app;
    const galReducer = state.galReducer;
    return {
        app: app,
        galReducer: galReducer,
    };
};

const mapDispatchToProps = {
    setStateVariable,
    updateStateVariables,
    openPopup
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux;

export default connector(GalleryPage);